import React from 'react';
import PropTypes from 'prop-types';
import { CodeHighlighter } from '@uhg-abyss/web/ui/CodeHighlighter';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Tabs } from '@uhg-abyss/web/ui/Tabs';
import { useParams } from '@uhg-abyss/web/tools/reactRouterTools';
import { LagoonContext } from '@src/AppContext';
import { SchemaTable } from './SchemaTable';

const BodyContainer = styled('div', {
  marginTop: 24,
});

export const Body = ({ body, currentApi }) => {
  const { service } = useParams();
  const formattedCode = JSON.stringify(body, null, 2);
  const lagoonContext = React.useContext(LagoonContext);
  const featureToggles = lagoonContext.getTable('configs');
  const serviceToggle = featureToggles?.getRow('SERVICE_TOGGLE')?.value;

  return (
    <BodyContainer>
      {serviceToggle?.includes(service) ? (
        <Tabs title="Arrow Variant" variant="arrow">
          <Tabs.Tab label="Schema">
            <SchemaTable currentApi={currentApi} />
          </Tabs.Tab>
          <Tabs.Tab label="Sample">
            <CodeHighlighter
              language="js"
              code={formattedCode}
              maxHeight="450px"
            />
          </Tabs.Tab>
        </Tabs>
      ) : (
        <CodeHighlighter language="js" code={formattedCode} maxHeight="450px" />
      )}
    </BodyContainer>
  );
};

Body.propTypes = {
  body: PropTypes.shape({}),
  currentApi: PropTypes.shape({}).isRequired,
};

Body.defaultProps = {
  body: null,
};
